let correlationId = null;

export const corrHeaderKey = 'X-Correlation-Id'

export function getCorrId() {
  return correlationId;
}

export function setCorrId(value) {
  if (correlationId == null) {
    correlationId = value;
  }
}

export function addCorrId(headers = new Headers()) {
  if (correlationId == null) return headers;

  if (headers instanceof Headers) {
    headers.set(corrHeaderKey, correlationId);
  } else {
    headers[corrHeaderKey] = correlationId;
  }

  return headers;
}

export function loadCorrId(headers) {
  if (correlationId) return headers;

  if (headers instanceof Headers && headers.has(corrHeaderKey)) {
    setCorrId(headers.get(corrHeaderKey));
  } else if (corrHeaderKey in headers && headers[corrHeaderKey]) {
    setCorrId(headers[corrHeaderKey]);
  }
}

export function tapAndLoadCorrId(response) {
  loadCorrId(response.headers);
  return response;
}
